import { AfterViewInit, Component, ViewChild, ElementRef, ChangeDetectorRef, Renderer2, OnDestroy, OnInit, HostListener } from '@angular/core';
import { ToastService } from '../../../../core/services/toast.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatService } from '../../services/chat.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { OpenApiService, Message, SummaryResponse } from '../../../../core/services/open-api.service';
import { marked } from 'marked';
import { AuthService } from '../../../../core/services/auth.service';
import { DeepgramService } from '../../services/deepgram.service';
import { HeaderComponent } from "../../../../shared/components/layout/header/header.component";
import { ActivatedRoute } from '@angular/router';
import { ChatStreamRelayWebSocketService } from '../../../../core/services/chat-stream-relay-websocket.service';

@Component({
  selector: 'app-user-chat-winodow',
  templateUrl: './user-chat-winodow.component.html',
  styleUrl: './user-chat-winodow.component.scss'
})
export class UserChatWinodowComponent implements OnDestroy, OnInit, AfterViewInit {
              public autoScrollAnimating = false;
            showAutoScrollToast() {
              // Use your toast service or a simple alert for demonstration
              if (this.toastService && typeof this.toastService.show === 'function') {
                // this.toastService.show('Auto-scroll stopped: reached bottom.', 'info', 3000);
              } else {
                // Fallback: simple alert
                // alert('Auto-scroll stopped: reached bottom.');
              }
            }
          private userIdleTimeout: any = null;
          private autoScrollSpeedup = false;
        isAutoScrolling = false;
      autoScrollEnabled = false;
      autoScrollOptions = [5, 7.5, 10, 12.5, 15, 17.5, 20, 22.5, 25]; 

      onAutoScrollToggle() {
        // Optionally, start/stop auto-scroll interval here
        if (this.autoScrollEnabled) {
          this.startAutoScrollInterval();
        } else {
          if (this.autoScrollInterval) {
            clearInterval(this.autoScrollInterval);
            this.autoScrollInterval = null;
          }
        }
      }

      onAutoScrollIntervalChange() {
        if (this.autoScrollEnabled) {
          this.startAutoScrollInterval();
        }
      }
    autoScrollIntervalSeconds = 10;
  isLinkExpired = false;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  userInput = '';
  recognition: any;
  isMicOn = false;
  isLoadingMessages = true;
  templateId: string = '';
  @ViewChild('zoomContainer', { static: false })
  zoomContainer!: ElementRef;
  showZoomIndicator = false;
  zoomLevel = 1;
  isStreaming = false;
  isNearBottom: boolean = true;
  isUserScrolling = false;

  // Auto-scroll while streaming properties
  private streamingAutoScrollInterval: any = null;
  // how many pixels to move every interval
  private autoScrollStep = 200; // pixels per interval
  // how often to auto-scroll while streaming (user requested 10 seconds)
  private autoScrollIntervalMs = 15000; // every 10 seconds
  private _programmaticScroll = false; // used to ignore scroll events caused by code
  private animationFrameId: number | null = null; // Track animation frame for cancellation

  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  private conversationSubscription: Subscription;
  private botMessageIndex: number = -1;
  menuOpen = false;
  // Removed unused property 'style'
  lastChunkTimestamp: any;
  @ViewChild('menuDropdown') menuDropdown!: ElementRef;

  constructor(
    public chatService: ChatService,
    private openApiService: OpenApiService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private authService: AuthService,
    private deepgramService: DeepgramService,
    private route: ActivatedRoute,
    private chatStreamRelayWebSocketService: ChatStreamRelayWebSocketService,
    private toastService: ToastService
  ) {
    // this.authService.setIsLoggedIn(true); // Set the user as logged in
    this.conversationSubscription = this.chatService.currentConversation$.subscribe(() => {
      // Don't auto-scroll during streaming - keep position at top
      // Only add copy buttons for code blocks
      setTimeout(() => this.addCopyButtonsToCodeBlocks(), 100);
    });
  }

  get currentConversation$() {
    return this.chatService.currentConversation$;
  }

  private autoScrollInterval: any = null;
  private uiNearBottomThreshold = 150; // px: how far from bottom before arrow shows



  ngOnInit(): void {
    // Get from route param first
    this.templateId = this.route.snapshot.paramMap.get('id') || '';
    console.log('Template ID from route:', this.templateId);

    // Override ONLY IF search param exists
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const queryTemplateId = urlParams.get('templateId');
      if (queryTemplateId) {
        this.templateId = queryTemplateId;
      }
    }

    console.log('Final Template ID:', this.templateId);
    let chatId = this.templateId;

    console.log('[UserChat] Connecting to relay WebSocket with chatId:', chatId);
    // this.chatService.selectConversation({
    //   id: '',
    //   title: '',
    //   messages: [],
    //   chatThreadId: ''
    // });
     if (this.templateId) {
 this.openApiService.getPromptById(this.templateId).subscribe({
        next: (prompt: any) => {
                  const now = Date.now();
        const promptTimestamp = Number(prompt.timestamp);
        const fourHoursMs = 4 * 60 * 60 * 1000;
        if (now - promptTimestamp > fourHoursMs) {
          this.isLoadingMessages = false;
          this.isLinkExpired = true;
          // Show expired link, do not set empty conversation
        } else {
          this.isLinkExpired = false;
          // Link is active, fetch chat history
          this.openApiService.getUserChatHistoryByPromptId(this.templateId).subscribe((history: any[]) => {
            if (history && history.length > 0) {
              this.isLoadingMessages = true;
              const reversedHistory = [...history].reverse();
              const messages = reversedHistory.flatMap(h => {
                const msgs: Message[] = [];
                if (h.answer) {
                  let botText = h.answer;
                  msgs.push({ text: botText, sender: 'bot', timestamp: new Date(h.timestamp) });
                }
                return msgs;
              });
              const conversation = {
                id: reversedHistory[0].chatThreadId || this.templateId,
                title: reversedHistory[0].question?.substring(0, 25) + '...' || 'Chat',
                messages,
                chatThreadId: reversedHistory[0].chatThreadId || this.templateId
              };
              this.chatService.selectConversation(conversation);
              // Scroll to bottom after loading messages
              setTimeout(() => {
                this.forceScrollToAbsoluteBottom();
              }, 300);
            } else {
              // No history, set empty conversation
              this.chatService.selectConversation({
                id: '',
                title: '',
                messages: [],
                chatThreadId: ''
              });
            }
            this.isLoadingMessages = false;
             });
          }
        },
        error: (err) => {
          this.isLoadingMessages = false;
          this.isLinkExpired = false;
          // Show toast for invalid/expired chat code (500 error)
          if (err && err.status === 500) {
            this.toastService.show('Invalid chat code. Please check your link or code', 'error', 4000);
          } else {
            this.toastService.show('An error occurred while loading the chat. Please try again.', 'error', 4000);
          }
          // Optionally, clear conversation
          this.chatService.selectConversation({
            id: '',
            title: '',
            messages: [],
            chatThreadId: ''
          });
        }
      });
    } else {
      // No templateId, set empty conversation
      this.chatService.selectConversation({
        id: '',
        title: '',
        messages: [],
        chatThreadId: ''
      });
    }

    let reconnectAttempts = 0;
    const maxReconnectAttempts = 10;
    const reconnect = () => {
      if (reconnectAttempts >= maxReconnectAttempts) {
        console.error('[UserChat] Max WebSocket reconnect attempts reached.');
        return;
      }
      reconnectAttempts++;
      setTimeout(() => {
        console.warn(`[UserChat] Relay WebSocket reconnect attempt ${reconnectAttempts}`);
        this.chatStreamRelayWebSocketService.connect(chatId, onChunk, onClose);
      }, Math.min(1000 * reconnectAttempts, 10000)); // Exponential backoff, max 10s
    };

    const onChunk = (chunk: string) => {
      // mark streaming in progress
      this.isStreaming = true;
      
      // Do NOT auto-scroll during streaming - keep scroll at top
      // User can manually scroll down to see streaming content if needed
      
      const now = Date.now();
      if (!this.lastChunkTimestamp) {
        this.lastChunkTimestamp = now;
      }
      const timeSinceLastChunk = now - this.lastChunkTimestamp;
      this.lastChunkTimestamp = now;

      // If more than 6s since last chunk, treat as new answer and create a new message box
      if (timeSinceLastChunk > 3000) {
        this.botMessageIndex = -1;
      } 

      this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
        if (currentConv) {
          if (this.botMessageIndex === -1) {
            // Immediately set to -2 to prevent duplicate message creation from rapid chunks
            this.botMessageIndex = -2;
            
            // Stop auto-scroll when new answer arrives
            const wasAutoScrolling = this.autoScrollEnabled;
            if (this.autoScrollInterval) {
              clearInterval(this.autoScrollInterval);
              this.autoScrollInterval = null;
            }
            this.isAutoScrolling = false;
            this.autoScrollAnimating = false;
            
            const placeholderMsg: Message = { text: '', sender: 'bot', timestamp: new Date() };
            this.chatService.addMessage(placeholderMsg);
            
            // Scroll to show 15% of previous answer with more bottom space
            setTimeout(() => {
              this.currentConversation$.pipe(take(1)).subscribe((updatedConv: any) => {
                this.botMessageIndex = updatedConv.messages.length - 1;
                // Set the first chunk for the new message
                this.chatService.updateBotMessage(this.botMessageIndex, chunk);
                this.cdr.detectChanges();
                
                // Position the new answer with proper spacing
                setTimeout(() => {
                  this.scrollToShowPreviousAndNewAnswer();
                  
                  // Restart auto-scroll after 2 seconds if it was enabled
                  if (wasAutoScrolling) {
                    setTimeout(() => {
                      this.autoScrollEnabled = true;
                      this.startAutoScrollInterval();
                    }, 2000);
                  }
                }, 100);
              });
            }, 0);
            return;
          }
          
          // If botMessageIndex is -2, we're still initializing, skip this chunk
          if (this.botMessageIndex === -2) {
            return;
          }

          // Deduplicate: Only append the new part of the chunk if it extends the current text
          const currentText = currentConv.messages[this.botMessageIndex]?.text || '';
          let updatedText = currentText;
          if (chunk && chunk !== currentText) {
            if (chunk.startsWith(currentText)) {
              // Only append the new part
              updatedText = chunk;
            } else if (!currentText || currentText.length === 0) {
              updatedText = chunk;
            } else {
              // If chunk is not a continuation, avoid appending to prevent overlap
              updatedText = chunk;
            }
            this.chatService.updateBotMessage(this.botMessageIndex, updatedText);
            this.cdr.detectChanges();
            // Don't auto-scroll during streaming - keep current position
          }
        }
      });
    };

    const onClose = () => {
      console.warn('[UserChat] Relay WebSocket closed, attempting to reconnect...');
      // mark streaming as ended
      this.isStreaming = false;
      reconnect();
    };

    this.chatStreamRelayWebSocketService.connect(chatId, onChunk, onClose);

    if (this.templateId) {
      this.openApiService.getPromptById(this.templateId).subscribe((prompt: any) => {
        const now = Date.now();
        const promptTimestamp = Number(prompt.timestamp);
        const fourHoursMs = 4 * 60 * 60 * 1000;
        if (now - promptTimestamp > fourHoursMs) {
          this.isLoadingMessages = false;
          this.isLinkExpired = true;  // Set the flag indicating the link is expired
        } else {
          this.isLinkExpired = false;  // Set the flag to false if the link is valid
          // Link is active, fetch chat history
          this.openApiService.getUserChatHistoryByPromptId(this.templateId).subscribe((history: any[]) => {
            if (history && history.length > 0) {
              this.isLoadingMessages = true;
              const reversedHistory = [...history].reverse();
              const messages = reversedHistory.flatMap(h => {
                const msgs: Message[] = [];
                if (h.answer) {
                  let botText = h.answer;
                  msgs.push({ text: botText, sender: 'bot', timestamp: new Date(h.timestamp) });
                }
                return msgs;
              });
              const conversation = {
                id: reversedHistory[0].chatThreadId || this.templateId,
                title: reversedHistory[0].question?.substring(0, 25) + '...' || 'Chat',
                messages,
                chatThreadId: reversedHistory[0].chatThreadId || this.templateId
              };
              this.chatService.selectConversation(conversation);
              // Scroll to bottom after loading messages
              setTimeout(() => {
                this.forceScrollToAbsoluteBottom();
              }, 300);
            }
            this.isLoadingMessages = false;
          });
        }
      });
    }

    // Don't auto-scroll on initial load - keep at top
    // this.scrollToBottom();
    this.addCopyButtonsToCodeBlocks();
    // this.scrollToBottomWithPadding(10)
    // this.startAutoScrollInterval();
  }

  ngAfterViewInit(): void {
    // this.startAutoScrollInterval();
    // console.log('[AutoScroll] 10s auto-scroll interval started in ngAfterViewInit');
    
    // Add event listeners to stop auto-scroll on user interaction
    if (this.scrollContainer?.nativeElement) {
      const el = this.scrollContainer.nativeElement;
      
      // Stop auto-scroll on mouse wheel - use capture phase to intercept before scroll
      el.addEventListener('wheel', () => this.stopAutoScrollOnUserAction(), { passive: false, capture: true });
      
      // Stop auto-scroll on touch move (mobile)
      el.addEventListener('touchstart', () => this.stopAutoScrollOnUserAction(), { passive: false, capture: true });
      el.addEventListener('touchmove', () => this.stopAutoScrollOnUserAction(), { passive: false, capture: true });
      
      // Also detect mousedown on scrollbar
      el.addEventListener('mousedown', () => this.stopAutoScrollOnUserAction(), { capture: true });
    }
  }

  onScroll(): void {
    // Ignore scroll events caused by our own programmatic scrolling
    if (this._programmaticScroll) {
      return;
    }
    const el = this.scrollContainer.nativeElement;
    // Stop auto-scroll immediately on user interaction
    this.stopAutoScrollImmediately();
    // still update near-bottom status for UI (with hysteresis)
    this.updateNearBottom(el);
    this.isUserScrolling = el.scrollTop + el.clientHeight < el.scrollHeight;
    // Restart auto-scroll after user is idle for 2 seconds
    if (this.userIdleTimeout) clearTimeout(this.userIdleTimeout);
    this.userIdleTimeout = setTimeout(() => {
      this.isUserScrolling = false;
      if (this.autoScrollEnabled) {
        this.startAutoScrollInterval();
      }
    }, 2000);
  }

  /**
   * Immediately stop auto-scroll animation and interval
   */
  private stopAutoScrollImmediately(): void {
    // Cancel any ongoing animation frame
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
    
    // Clear the interval
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
    
    // Reset all flags immediately
    this.isAutoScrolling = false;
    this.autoScrollAnimating = false;
    this._programmaticScroll = false;
    this.autoScrollSpeedup = true; // Next scroll will be faster
  }

  /**
   * Called when user initiates scroll action (wheel, touch)
   */
  private stopAutoScrollOnUserAction(): void {
    // Only stop if currently auto-scrolling or animating
    if (this.isAutoScrolling || this.autoScrollAnimating) {
      this.stopAutoScrollImmediately();
    }
  }

  /**
   * Hysteresis for isNearBottom: prevents flicker of the scroll-to-bottom arrow.
   * - Show arrow if > 260px from bottom
   * - Hide arrow if < 160px from bottom
   */
  private updateNearBottom(el: HTMLElement) {
    const distance = el.scrollHeight - el.scrollTop - el.clientHeight;
    if (distance < 160) {
      this.isNearBottom = true;
    } else if (distance > 260) {
      this.isNearBottom = false;
    }
  }

  ngOnDestroy() {
    // Stop all animations and intervals
    this.stopAutoScrollImmediately();
    if (this.userIdleTimeout) clearTimeout(this.userIdleTimeout);
    
    // Note: Event listeners don't need manual removal as they're attached to the element
    // which will be destroyed when the component is destroyed
    
    // this.authService.setIsLoggedIn(false);
    this.conversationSubscription.unsubscribe();
    this.chatStreamRelayWebSocketService.close();
  }


  async typeBotMessage(fullText: string, messageIndex: number) {
    const parts = fullText.split(/(```[\s\S]*?```)/);
    let currentText = '';

    for (const part of parts) {
      currentText += part;
      this.chatService.updateBotMessage(messageIndex, currentText);
      if (!part.startsWith('```')) {
        await new Promise(res => setTimeout(res, 20)); // Type regular text quickly
      } else {
        await new Promise(res => setTimeout(res, 50)); // Pause slightly for code blocks
      }
    }
    this.chatService.finalizeConversation();
    this.cdr.detectChanges();
    this.addCopyButtonsToCodeBlocks();
  }





  formatMessage(text: string): SafeHtml {
    const parsed = marked.parse(text);
    return parsed;
  }

  copyCodeBlock(index: number) {
    this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
      if (!currentConv || !currentConv.messages[index]) return;
      const msg = currentConv.messages[index];
      // Extract code block from message text
      const codeMatch = msg.text.match(/```([\s\S]*?)```/);
      if (codeMatch && codeMatch[1]) {
        const code = codeMatch[1].trim();
        navigator.clipboard.writeText(code);
      }
    });
  }

  addCopyButtonsToCodeBlocks() {
    if (!this.scrollContainer?.nativeElement) return;
    const preElements = this.scrollContainer.nativeElement.querySelectorAll('pre');
    preElements.forEach((pre: HTMLElement, idx: number) => {
      if (pre.querySelector('.copy-btn')) return;
      // ensure pre is positioned relatively so absolute button positions correctly
      if (!pre.style.position) {
        pre.style.position = pre.style.position || 'relative';
      }

      // create a real button element for accessibility
      const button = this.renderer.createElement('icon');
      this.renderer.addClass(button, 'copy-btn');
      this.renderer.setAttribute(button, 'type', 'button');
      this.renderer.setAttribute(button, 'aria-label', 'Copy code');
      // initial icon (copy)
      button.innerHTML = '<mat-icon class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color">content_copy</mat-icon>';

      // click handler with visual feedback
      const onClick = async (ev: Event) => {
        ev.stopPropagation();
        const code = pre.querySelector('code')?.innerText || pre.innerText || '';
        try {
          await navigator.clipboard.writeText(code);
          // show tick icon + copied class
          button.innerHTML = '<mat-icon class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color">check_circle</mat-icon>';
          this.renderer.addClass(button, 'copied');
          // optional small animation: scale then revert
          setTimeout(() => {
            // revert to copy icon
            button.innerHTML = '<mat-icon class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color">content_copy</mat-icon>';
            this.renderer.removeClass(button, 'copied');
          }, 1500);
        } catch (err) {
          // fallback: do nothing but remove any copied state
          this.renderer.removeClass(button, 'copied');
        }
      };

      // Use renderer.listen so Angular cleans up if element removed
      this.renderer.listen(button, 'click', (ev: Event) => { onClick(ev as Event).catch(() => { }); });
      this.renderer.appendChild(pre, button);
    });
  }

  // scrollToBottom(): void {
  //   try {
  //     this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  //   } catch (err) { }
  // }

  summarizeConversation() {
    this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
      // Removed summarizeConversation logic
    });
  }


  copyToClipboard(msg: Message): void {
    navigator.clipboard.writeText(msg.text).then(() => {
      msg.copied = true;

      setTimeout(() => {
        msg.copied = false;
      }, 2000); // Reset after 2 seconds
    });
  }

  onZoomIn() {
    let newPercentage = this.zoomLevel * 100 + 10;
    this.setZoomPercentage(newPercentage);
  }

  onZoomOut() {
    let newPercentage = this.zoomLevel * 100 - 10;
    this.setZoomPercentage(newPercentage);
  }

  get zoomDisplayValue(): string {
    return Math.round(this.zoomLevel * 100) + '%';
  }

  setZoom(change: number) {
    this.zoomLevel = Math.min(Math.max(this.zoomLevel + change, 0.5), 2);
    if (this.zoomContainer && this.zoomContainer.nativeElement) {
      const baseFontSize = 14; // base font size in px
      const newFontSize = baseFontSize * this.zoomLevel;
      this.zoomContainer.nativeElement.style.fontSize = `${newFontSize}px`;
      this.zoomContainer.nativeElement.style.lineHeight = (newFontSize * 1.4) + 'px';
    }

  }

  setZoomPercentage(percentage: number) {
    this.zoomLevel = Math.min(Math.max(percentage / 100, 0.5), 2);
    const baseFontSize = 14;
    const newFontSize = baseFontSize * this.zoomLevel;
    if (this.zoomContainer?.nativeElement) {
      this.zoomContainer.nativeElement.style.fontSize = `${newFontSize}px`;
      this.zoomContainer.nativeElement.style.lineHeight = `${newFontSize * 1.4}px`;
    }
    this.showZoomIndicator = true;
    // Hide after 2 seconds automatically (optional)
    setTimeout(() => this.showZoomIndicator = false, 10000);
  }

  toggleZoomIndicator() {
    this.showZoomIndicator = !this.showZoomIndicator;
  }

  resetZoom() {
    console.log("zoom clicked")
    this.zoomLevel = 1;
    const baseFontSize = 14;
    if (this.zoomContainer?.nativeElement) {
      this.zoomContainer.nativeElement.style.fontSize = `${baseFontSize}px`;
      this.zoomContainer.nativeElement.style.lineHeight = `${baseFontSize * 1.4}px`;
    }
    this.showZoomIndicator = true;
    setTimeout(() => this.showZoomIndicator = false, 100);
    this.cdr.detectChanges();
  }


  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.menuOpen && this.menuDropdown && !this.menuDropdown.nativeElement.contains(event.target)) {
      this.menuOpen = false;
    }
  }


  scrollToBottom(force: boolean = false): void {
    try {
      if (!this.isUserScrolling || force) {
        // mark as programmatic so onScroll ignores it
        this._programmaticScroll = true;
        const el = this.scrollContainer.nativeElement;
        el.scrollTop = el.scrollHeight;
        this.updateNearBottom(el);
        // clear programmatic flag shortly after
        setTimeout(() => { this._programmaticScroll = false; }, 120);
      }
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }

  /**
   * Force scroll to the absolute bottom of the chat, ignoring all flags.
   */
  forceScrollToAbsoluteBottom(): void {
    try {
      if (this.scrollContainer?.nativeElement) {
        this._programmaticScroll = true;
        const el = this.scrollContainer.nativeElement;
        el.scrollTop = el.scrollHeight;
        this.updateNearBottom(el);
        setTimeout(() => { this._programmaticScroll = false; }, 120);
      }
    } catch (err) {
      console.error('Force scroll error:', err);
    }
  }


  // This method is triggered when the user starts scrolling
  onUserScroll(): void {
    const scrollTop = this.scrollContainer.nativeElement.scrollTop;
    const scrollHeight = this.scrollContainer.nativeElement.scrollHeight;
    const clientHeight = this.scrollContainer.nativeElement.clientHeight;

    // User is scrolling manually, we set the flag to true
    this.isUserScrolling = true;

    // Check if the user is near the bottom (e.g., within 50px of the bottom)
    // Use hysteresis logic for isNearBottom
    this.updateNearBottom(this.scrollContainer.nativeElement);
  }

  // This method is triggered when the user stops scrolling
  onUserStopScroll(): void {
    setTimeout(() => {
      if (!this.isStreaming && this.isNearBottom) {
        this.isUserScrolling = false;
        this.scrollToBottom(true);
      }
    }, 1000); // shorter, more responsive
  }

  scrollToBottomWithPadding(padding = 10) {
    const container = this.scrollContainer.nativeElement;
    if (!this.isUserScrolling) { // respects manual user scroll
      this._programmaticScroll = true;
      container.scrollTop = container.scrollHeight - container.clientHeight - padding;
      setTimeout(() => { this._programmaticScroll = false; }, 120);
    }
  }

  /**
   * Called by the template arrow click
   */
  onScrollToBottomClick(): void {
    // user intentionally clicked to go to bottom; force immediate scroll
    this.isUserScrolling = false;
    this.scrollToBottom(true);
  }

  /**
   * Scroll to show last 15% of previous answer and provide more space for new answer
   */
  scrollToShowPreviousAndNewAnswer(): void {
    setTimeout(() => {
      try {
        if (!this.scrollContainer || !this.scrollContainer.nativeElement) return;
        
        const container = this.scrollContainer.nativeElement;
        const messageElements = container.querySelectorAll('.message-wrapper');
        
        if (messageElements.length < 1) {
          return;
        }
        
        if (messageElements.length === 1) {
          // Only one message, position it at top
          this._programmaticScroll = true;
          container.scrollTop = 0;
          this.updateNearBottom(container);
          setTimeout(() => { this._programmaticScroll = false; }, 120);
          return;
        }
        
        // Get the second-to-last message (previous answer)
        const previousMsg = messageElements[messageElements.length - 2] as HTMLElement;
        
        const previousMsgHeight = previousMsg.offsetHeight;
        const previousMsgTop = previousMsg.offsetTop;
        
        // Show last 15% of previous message at top
        const targetScrollTop = previousMsgTop + (previousMsgHeight * 0.85);
        
        this._programmaticScroll = true;
        container.scrollTop = Math.max(0, targetScrollTop);
        this.updateNearBottom(container);
        
        setTimeout(() => { this._programmaticScroll = false; }, 120);
      } catch (err) {
        console.error('Scroll to previous/new answer error:', err);
      }
    }, 150);
  }

  // private startStreamingAutoScroll(): void {
  //   // restart autoscroll so duration counts from latest chunk
  //   this.stopStreamingAutoScroll();

  //   this.streamingAutoScrollInterval = setInterval(() => {
  //     try {
  //       if (!this.scrollContainer || !this.scrollContainer.nativeElement) return;

  //       const el = this.scrollContainer.nativeElement;
  //       const remaining = el.scrollHeight - el.scrollTop - el.clientHeight;
  //       if (remaining <= 0) {
  //         // reached bottom
  //         this.stopStreamingAutoScroll();
  //         this.updateNearBottom(el);
  //         this.isStreaming = false;
  //         return;
  //       }

  //       const step = Math.min(this.autoScrollStep, remaining);
  //       this._programmaticScroll = true;
  //       el.scrollTop = el.scrollTop + step;
  //       // if we are close now, mark near bottom
  //       this.updateNearBottom(el);
  //       // clear flag shortly after
  //       setTimeout(() => { this._programmaticScroll = false; }, 120);
  //     } catch (err) {
  //       // swallow
  //     }
  //   }, this.autoScrollIntervalMs);
  // }

  private stopStreamingAutoScroll(): void {
    if (this.streamingAutoScrollInterval) {
      clearInterval(this.streamingAutoScrollInterval);
      this.streamingAutoScrollInterval = null;
    }
    // mark streaming as ended
    this.isStreaming = false;
  }
  private startAutoScrollInterval() {
    if (this.autoScrollInterval) clearInterval(this.autoScrollInterval);
    // Use the selected interval time (default to 15s if not set)
    const intervalMs = (this.autoScrollIntervalSeconds || 15) * 1000;
    this.isAutoScrolling = true;
    // Hide scroll-to-bottom icon for the entire auto-scroll session
    let autoScrollActive = true;
    this.autoScrollInterval = setInterval(() => {
      if (!this.scrollContainer?.nativeElement) return;
      const el = this.scrollContainer.nativeElement;
      const remaining = el.scrollHeight - el.scrollTop - el.clientHeight;
      // If already at the bottom, just wait for next interval (don't stop auto-scroll)
      if (remaining <= 0 || Math.abs(el.scrollTop - (el.scrollHeight - el.clientHeight)) < 2) {
        // Already at bottom, keep auto-scroll enabled and wait for next interval
        return;
      }
      // Scroll distance is proportional to interval (e.g., 1/5th of container height)
      const proportionalStep = Math.max(80, Math.floor(el.clientHeight / 5));
      const step = proportionalStep;
      this._programmaticScroll = true;
      this.autoScrollAnimating = true;
      // Make initial scroll smooth, subsequent scrolls faster
      let duration;
      if (!this.autoScrollSpeedup) {
        duration = Math.max(800, Math.floor(intervalMs * 0.8)); // smooth, longer animation
      } else {
        duration = Math.max(300, Math.floor(intervalMs * 0.3)); // faster after user interaction
      }
      const start = el.scrollTop;
      const end = Math.min(el.scrollTop + step, el.scrollHeight - el.clientHeight);
      const startTime = performance.now();
      const animate = (now: number) => {
        // Check if animation was cancelled
        if (!this.autoScrollAnimating) {
          this._programmaticScroll = false;
          return;
        }
        const elapsed = now - startTime;
        // Ease-in-out timing function
        const t = Math.min(elapsed / duration, 1);
        const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        el.scrollTop = start + (end - start) * ease;
        if (t < 1) {
          this.animationFrameId = requestAnimationFrame(animate);
        } else {
          this._programmaticScroll = false;
          this.autoScrollAnimating = false;
          this.animationFrameId = null;
        }
      };
      this.animationFrameId = requestAnimationFrame((now) => animate(now));
    }, intervalMs);
  }


}
